import React, { PropTypes, Component } from 'react';
import styles from './slide.scss';
import buttons from 'shared-styles/buttons.scss';
import transition from '../../../modules/css-transition';

class Slide extends Component {
  componentDidMount() {
    if(transition.isSupported && this.props.onTransitionEnd) {
      this.bindTransitionEnd();
    }
  }

  bindTransitionEnd() {
    this.refs.slide.addEventListener(transition.event, (e) => {
      if(e.target.className.indexOf(styles.active) > -1) {
        this.props.onTransitionEnd(e);
      }
    });
  }

  render() {
    let classes = styles.slide;
    if(this.props.isActive) {
      classes += ` ${styles.active}`;
    }

    const desktopStyle = { backgroundImage: `url(${this.props.desktopImg})` };
    const mobileStyle = { backgroundImage: `url(${this.props.mobileImg})` };
    const elementImgStyle = { backgroundImage: `url(${this.props.elementImg})` };

    return (
      <div className={classes} ref='slide'>
        <div className={styles['desktop-bg']} style={desktopStyle}></div>
        <div className={styles['mobile-bg']} style={mobileStyle}></div>
        <div className={styles['content-container']}>
          <p className={styles.title}>{ this.props.title }</p>
          <p className={styles['second-title']}>{ this.props.secondTitle }</p>
          <p className={styles.subtitle}>{ this.props.subtitle }</p>
          <div className={styles['element-image']} style={elementImgStyle}></div>
          <a
            className={`${buttons.baseButton} ${buttons.clearWhite} ${styles.heroButton}`}
            href={this.props.url}
          >
            {this.props.ctaCopy}
          </a>
        </div>
      </div>
    );
  }
}

Slide.propTypes = {
  desktopImg: PropTypes.string.isRequired,
  mobileImg: PropTypes.string.isRequired,
  elementImg: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  secondTitle: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  onTransitionEnd: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
  ctaCopy: PropTypes.string.isRequired,
};

export default Slide;



/** WEBPACK FOOTER **
 ** ./shared-components/FadeCarouselSide/components/Slide.js
 **/